import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { TripDeliveryHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/trip/trip-delivery-hdr-container.model';
import { ApiVisa, Pagination } from '../../../shared';
import { ApiResponseModel, PagingResponseModel } from '../../../shared/api-response.model';
import { TripSearchDto } from '../../../../data-transfer-objects/trip-search-dto.model';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class TripHdrService extends BaseApiTemplateService<TripDeliveryHeaderContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/trips
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips';
    this.httpClient = http;
  }

  public createTrip(payload: any, visa: ApiVisa) {
    let url = this.apiUrl + '/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep';
    }
    return this.httpClient.post(url, payload, this.getHttpHeader(visa))
  }

  public printTripWithJobDetails(formatGuid: string, visa: ApiVisa, body: any) {
    let url = this.apiUrl + '/job-details/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/job-details/batch-print-jasper-pdf/backoffice-ep?printableFormatHdrGuid=' + formatGuid;
    }
    return this.httpClient.post(url, body, this.getHttpHeaderBlob(visa))
  }

  public getBySnapshotQueryTrips(dtoObject: TripSearchDto, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/query/snapshot';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getTripBySnapshot(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/getTrip/query';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getAllTrips(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep';
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public completeTrips(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/backoffice-ep/complete-trips';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/backoffice-ep/complete-trips';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  public cancelTrips(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/backoffice-ep/cancel-trips';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/backoffice-ep/cancel-trips';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa))
  }

  public startTrips(visa: ApiVisa, dtoObject) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/trips-start/backoffice-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path +  '/trips-start/backoffice-ep';
    }
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa))
  }

  public printJasperPdfFlatFormat(dtoObject: any, printableFormatHdrGuid:String, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/job-details/batch-print-jasper-pdf-flat-format/backoffice-ep?printableFormatHdrGuid='+printableFormatHdrGuid;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeaderBlob(visa)
    );
  }

  addExistingJobsToTrip(visa: ApiVisa, body: any) {
    let url = this.apiUrl + '/backoffice-ep/jobs-add-trip';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/backoffice-ep/jobs-add-trip' ;
    }
    return this.httpClient.post(url, body, this.getHttpHeader(visa));
  }

  getByCriteriaWebsiteEp(
    pagination: Pagination,
    visa: ApiVisa,
    websiteHdrGuid?: string,
  ): Observable<PagingResponseModel<TripDeliveryHeaderContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trips/get-trip/website-ep/' + websiteHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/get-trip/website-ep/' + websiteHdrGuid;
    }
    const UrlByCriteria =
      url + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<TripDeliveryHeaderContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
